function normalizeParams(params) {
  if (typeof params === "string") return params;
  return JSON.stringify(params, Object.keys(params).sort());
}

export function createActiveScopes() {
  const active = {};

  function set(scope, key, { syncEngine, repository, repositories, syncFn, syncParams } = {}) {
    if (active[scope] === undefined) {
      active[scope] = {};
    }

    const activeScope = active[scope];
    if (activeScope[key] === undefined) {
      activeScope[key] = [];
    }

    const activeScopeKey = activeScope[key];
    activeScopeKey.push({ scope, syncEngine, repository, repositories, syncFn, syncParams });
  }

  function remove(scope, key) {
    const activeScope = active[scope];
    if (activeScope === undefined) return;

    const activeScopeKey = activeScope[key];
    if (activeScopeKey === undefined) return;
    
    activeScopeKey.pop();

    if (activeScopeKey.length === 0) {
      delete activeScope[key];
    }
  }

  function getAll() {
    const result = [];
    for (const [scope, key] of Object.entries(active)) {
      for (const [key, array] of Object.entries(active[scope])) {
        const { scope, syncEngine, repository, repositories, syncFn, syncParams } = array[0];
        result.push({ scope, syncEngine, repository, repositories, syncFn, syncParams })
      }
    }
    return result;
  }

  return {
    set,
    remove,
    getAll,
  };
}
